import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchGet } from '../../../store/openApiFetch';
import { PanelBody, Table, TableBody, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../../elements';
import { Spinner } from '../../spinners';
import { EquipmentExpirationLabel } from '../../utils/equipmentExpirationLabel';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadEquipmentPayload({ equipmentId }: { equipmentId: string }) {
    const result = await openApiFetchGet('/api/equipmentPayload', { equipmentId });
    return result;
}

export function EquipmentPayloadList(props: { equipmentId: string }) {
    const translate = useTranslate();
    const navigate = useNavigate();
    const { data, isLoading } = useReactAsync(loadEquipmentPayload, { equipmentId: props.equipmentId }, [props.equipmentId]);

    return (
        <>
            {(isLoading && <Spinner />) || (
                <PanelBody noPadding>
                    <Table hover>
                        <TableHead>
                            <TableHeadRow light={true}>
                                <TableHeader>{translate('common.name')}</TableHeader>
                                <TableHeader>{translate('common.type')}</TableHeader>
                                <TableHeader>{translate('common.status')}</TableHeader>
                                <TableHeader align="right">{translate('equipment.expirationDate')}</TableHeader>
                            </TableHeadRow>
                        </TableHead>
                        <TableBody>
                            {data &&
                                data.map((item) => (
                                    <TableRow key={item.id} onClick={() => navigate(`/equipment/${item.id}`)}>
                                        <TableData> {item.name} </TableData>
                                        <TableData> {item.equipmentType.name} </TableData>
                                        <TableData> {translate(`equipment.${item.status}`)}</TableData>
                                        <TableData alignRight>
                                            {' '}
                                            <EquipmentExpirationLabel data={item} />
                                        </TableData>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </PanelBody>
            )}
        </>
    );
}
